import React, { Component } from "react";
import PropTypes from "prop-types";
import { message } from "antd";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import queryString from "query-string";
import { fetchGrantData } from "../../../GrantsActivity/actions";
import {
  SectionHeading,
  TableLabel,
  SectionMediumDivider,
  AlertWrap,
} from "../../style";
import {
  changeNoOfPayments,
  cancelGrantFlow,
  addSpawn,
  updateIndividualSpawn,
  cancelAllSchedules,
  cancelSchedule,
} from "../../actions";
import FlowFooter from "../FlowFooter/FlowFooter";
import { spawnFormatter, arrayChecker } from "../../utils";
import RecurringEditableTable from "../RecurringEditableTable/RecurringEditableTable";
import { checkCSRBusinessFunction } from "../../../../../../CSR/utils/CommonUtils";
import { BUSINESS_FUNCTION } from "../../../../../../CSR/utils/csrBusinessFunctionMapper";
import { initiateTracking } from "../../../../../../utils/commonUtil";
import DrupalPopup from "../Popup/DrupalPopup";
import {
  AlertContent,
  Types,
} from "../../../../../../CommonComponents/ContentMessages";
import { CommonListWrapper } from "../../../../../../CommonComponents/commonStyles";
import regexMap from "../../../../../../utils/regexMap";
import { customizeSpawnDerivedStates } from '../../Selectors/CustomizeSpawnSelectors';

export class CustomizeSpawn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonFlag: false,
      spawnsCollection: spawnFormatter(this.props.spawns),
      editedSpawns: [],
      resetData: null,
      resetIndex: null,
      showLowGrantAmount: false,
    };
    this.warningContents = {
      cancel:
        "This will discard your changes. Are you sure you want to move forward?",
    };
    this.spawnCopy = spawnFormatter(this.props.spawns);
    this.pageRender = this.pageRender.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.cancelSingleStatus || nextProps.cancelAllStatus)
      this.pageRender();
    if (nextProps.updateSpawn) this.updateSpawnRender();
  }

  updateSpawnRender() {
    this.props.history.push({
      pathname: "/grants/activity/view",
      search: queryString.stringify({
        scheduleId: this.props.location.state.scheduleId,
      }),
    });
  }

  pageRender() {
    this.props.fetchGrantData({
      userId: this.props.accountId,
      scheduleId: this.props.location.state.scheduleId,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.spawns !== prevProps.spawns) {
      this.setState({ spawnsCollection: spawnFormatter(this.props.spawns) });
      this.spawnCopy = spawnFormatter(this.props.spawns);
    }
  }

  addGrantApiCall = () => {
    let page = this;
    initiateTracking(
      "addGrant2",
      "Customize Recurring Grant",
      "",
      "Add Grant - Recurring Grant"
    );
    this.props.addSpawn({
      userId: this.props.accountId,
      scheduleId: this.props.location.state.scheduleId,
      successFn: () => {
        message.success(
          `A new spawn ${
            page.spawnCopy[page.spawnCopy.length - 1].grantName
          } has been added to the schedule.`
        );
      },
      failureFn: () => {
        message.error("Sorry, Something went wrong.");
      },
    });
  };

  addGrandHandler = () => {
    return this.addGrantApiCall();
  };

  redundancyCheck = (val, array) => {
    if (array.length > 0) return array.includes(val);
    return false;
  };

  resetHandler = ({ changedArray, index, spawnId }) => {
    if (this.spawnCopy && 
      JSON.stringify(changedArray[index]) ===
      JSON.stringify(this.spawnCopy[index])
    ) {
      if (
        this.state.editedSpawns.length > 0 &&
        this.redundancyCheck(spawnId, this.state.editedSpawns)
      ) {
        const refactoredSpawn = this.state.editedSpawns.filter(
          (val) => val !== spawnId
        );
        this.setState({ editedSpawns: refactoredSpawn });
      }
    } else {
      if (!this.redundancyCheck(spawnId, this.state.editedSpawns)) {
        const tempSpawnIds = [...this.state.editedSpawns];
        tempSpawnIds.push(spawnId);
        this.setState({ editedSpawns: tempSpawnIds });
      }
    }
  };

  handleInputChange = (i, e) => {
    let changedSpawn = "";
    const tempArr = this.state.spawnsCollection.map((item, index) => {
      if (index === i && regexMap.twoDecimal.test(e.target.value)) {
        item.amount = e.target.value;
        changedSpawn = item.spawnId;
      }
      return item;
    });
    this.resetHandler({
      changedArray: tempArr,
      index: i,
      spawnId: changedSpawn,
    });
    this.setState({ spawnsCollection: tempArr });
    let check = arrayChecker(tempArr, this.spawnCopy);
    this.setState({ buttonFlag: !check });
  };

  dateChangeHandle = (e, date, i) => {
    let changedSpawn = "";
    let tempArr = this.state.spawnsCollection;
    tempArr.forEach((item, index) => {
      if (index === i) item.scheduledDate = date;
    });
    for (let j = 0; j < tempArr.length; j++) {
      if (i === j) changedSpawn = tempArr[j].spawnId;
    }
    this.resetHandler({
      changedArray: tempArr,
      index: i,
      spawnId: changedSpawn,
    });
    this.setState({ spawnsCollection: tempArr });
    let check = arrayChecker(tempArr, this.spawnCopy);
    this.setState({ buttonFlag: !check });
  };

  handleInputBlur = (e, resetData, resetIndex) => {
    const check = arrayChecker(this.state.spawnsCollection, this.spawnCopy);
    const currentState = {};
    if (e.target.value < 500) {
      currentState.showLowGrantAmount = true;
      currentState.resetData = resetData;
      currentState.resetIndex = resetIndex;
    }
    this.setState({ buttonFlag: !check, ...currentState });
  };

  resetGrantAmount = () => {
    this.individualResetHandler(this.state.resetData, this.state.resetIndex);
    this.setState({ showLowGrantAmount: false });
  };

  arrayLastIndexDetail = ({ collection, key }) => {
    if (collection.length > 0) {
      let tempObj = collection[collection.length - 1];
      return tempObj[key];
    }
    return null;
  };

  handleUpdateCta = () => {
    const updatedSpawns = this.state.spawnsCollection.filter((each) => {
      return this.state.editedSpawns.includes(each.spawnId);
    });
    let tempArray = updatedSpawns.map((item) => ({
      spawnId: item.spawnId,
      issueDate: moment(item.scheduledDate).format("YYYY-MM-DD"),
      amount: item.amount,
    }));
    initiateTracking(
      "update2",
      "Customize Recurring Grant",
      "",
      "Update - Recurring Grant"
    );
    if(tempArray && tempArray.length) {
      this.props.updateSpawns({
        userId: this.props.accountId,
        updateData: {
          scheduleId: this.props.location.state.scheduleId,
          spawns: tempArray,
        },
      });
    } else {
      this.props.history.push({
        pathname: "/grants/activity/view",
        search: queryString.stringify({
          scheduleId: this.props.location.state.scheduleId,
        }),
      });
    }
  };

  individualResetHandler = (spawn, index) => {
    const tempSpawns = this.state.spawnsCollection.map((val, i) => {
      if (i === index) {
        val.amount = this.spawnCopy[index].amount;
        val.scheduledDate = this.spawnCopy[index].scheduledDate;
      }
      return val;
    });
    this.resetHandler({
      changedArray: tempSpawns,
      index,
      spawnId: spawn.spawnId,
    });
    this.setState({ spawnsCollection: tempSpawns });
    const check = arrayChecker(tempSpawns, this.spawnCopy);
    this.setState({ buttonFlag: !check });
  };

  cancelApi = (currentSpawnId, type, status) => {
    let page = this;
    const { history } = this.props;
    const spawnName = this.spawnCopy && this.spawnCopy.filter((spawn) => {
      if (spawn.spawnId === currentSpawnId) return spawn;
    });
    initiateTracking(
      `${type === "all" ? `cancel2` : `cancelTable`}`,
      "Customize Recurring Grant",
      `${status ? status : ""}`,
      `${
        type === "all" ? `Cancel all remaining payments` : `Cancel`
      } - Recurring Grant`
    );
    switch (type) {
      case "all":
        return this.props.cancelAllSpawns({
          userId: this.props.accountId,
          cancelData: {
            accountId: this.props.accountId,
            scheduleId: this.props.location.state.scheduleId,
            grantType: "recurring",
          },
          successFn: () => {
            message.success(
              "All remaining payments have been cancelled successfully."
            );
            history.goBack();
          },
          failureFn: () => {
            message.error("Sorry, Something went wrong.");
          },
        });
      case "single":
        return this.props.cancelSingleSpawn({
          userId: this.props.accountId,
          scheduleId: this.props.location.state.scheduleId,
          pendingSpawnId: currentSpawnId,
          cancelData: {
            accountId: this.props.accountId,
            scheduleId: this.props.location.state.scheduleId,
            pendingSpawnId: currentSpawnId,
            grantType: "recurring",
          },
          successFn: () => {
            if (spawnName.length) {
              message.success(
                `Spawn '${spawnName[0].grantName}' has been cancelled successfully.`
              );
            }
          },
          failureFn: () => {
            message.error("Sorry, Something went wrong.");
          },
        });
    }
  };

  handleUpdateCancel = () => {
    initiateTracking(
      `${this.state.buttonFlag ? "cancel2" : "back2"}`,
      "Customize Recurring Grant",
      "",
      `${this.state.buttonFlag ? "Cancel Edit" : "Back"} - Recurring Grant`
    );
    this.props.history.push({
      pathname: "/grants/activity/view",
      search: queryString.stringify({
        scheduleId: this.props.location.state.scheduleId,
      }),
    });
  };

  render() {
    const {
      grantName,
      grantAmount,
      frequency,
      startDate,
      noOfPayment,
      enableCancelPopUp, // passed from parent
      csrBusinessFunction,
    } = this.props;
    let grantsDetails = {
      grantName,
      grantAmount,
      frequency,
      startDate,
      noOfPayment,
    };
    return (
      <div>
        <RecurringEditableTable
          grantsDetails={grantsDetails}
          spawns={this.state.spawnsCollection}
          editedSpawns={this.state.editedSpawns}
          handleInputBlur={this.handleInputBlur}
          dateChangeHandle={this.dateChangeHandle}
          addGrandHandler={this.addGrandHandler}
          individualResetHandler={this.individualResetHandler}
          handleInputChange={this.handleInputChange}
          cancelApi={this.cancelApi}
          csrBusinessFunction={csrBusinessFunction}
        />
        <SectionHeading>Please Note:</SectionHeading>
        <TableLabel className="mt-20">
          <CommonListWrapper>
            <AlertContent
              page={"Customize Recurring Grant"}
              type={[Types.PAGE_PLEASE_NOTE]}
              keyProperty={"Recurring Edit"}
              property={"field_please_note_content"}
              html={true}
              defaultMessage={
                "The updated grant amount will be calculated based on allocation percentage decided in earlier stages"
              }
            />
          </CommonListWrapper>
        </TableLabel>
        <SectionMediumDivider />
        <FlowFooter
          edit="true"
          page={"Edit Grant"}
          keyPropertyUpdate={"Cancel Edit Grant"}
          updateCancelLabel={this.state.buttonFlag ? "Cancel Edit" : "Back"}
          enableCancelPopUp={enableCancelPopUp && this.state.buttonFlag}
          enableUpdate={
            this.props.applicable_business_function && !checkCSRBusinessFunction(
              BUSINESS_FUNCTION[this.props.applicable_business_function[0]],
              this.props.csrBusinessFunction
            )
          }
          handleUpdateCta={this.handleUpdateCta}
          handleUpdateCancel={this.handleUpdateCancel}
        />

        <DrupalPopup
          html={true}
          page={"Edit Grant"}
          show={this.state.showLowGrantAmount}
          defaultPrimaryLabel={"Ok"}
          defaultTitle={"Error"}
          showSecondary={false}
          keyProperty={"Minimum Amount Edit Grant"}
          defaultDescription={"Enter a minimum of $500."}
          primaryCta={this.resetGrantAmount}
          alertId="minimum-amount"
        />
      </div>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  changeNoOfPayments: (payload) => dispatch(changeNoOfPayments(payload)),
  cancelGrantFlow: (payload) => dispatch(cancelGrantFlow(payload)),
  updateSpawns: (payload) => dispatch(updateIndividualSpawn(payload)),
  addSpawn: (payload) => dispatch(addSpawn(payload)),
  cancelSingleSpawn: (payload) => dispatch(cancelSchedule(payload)),
  cancelAllSpawns: (payload) => dispatch(cancelAllSchedules(payload)),
  fetchGrantData: (data) => dispatch(fetchGrantData(data)),
});

const mapStateToProps = (state) => ({
  ...customizeSpawnDerivedStates(state.toJS())
});

CustomizeSpawn.propTypes = {
  accountId: PropTypes.string.isRequired,
  addSpawn: PropTypes.func,
  analyticsHandler: PropTypes.func,
  applicable_business_function: PropTypes.any,
  cancelAllSpawns: PropTypes.func,
  cancelAllStatus: PropTypes.bool,
  cancelGrantFlow: PropTypes.func,
  cancelSingleSpawn: PropTypes.func,
  cancelSingleStatus: PropTypes.bool,
  changeNoOfPayments: PropTypes.func,
  csrBusinessFunction: PropTypes.any,
  enableCancelPopUp: PropTypes.bool,
  fetchGrantData: PropTypes.func,
  frequency: PropTypes.string,
  grantAmount: PropTypes.string,
  grantName: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
  location: PropTypes.shape({
    state: PropTypes.object.isRequired,
  }),
  noOfPayment: PropTypes.string,
  onUpdate: PropTypes.func.isRequired,
  scheduleId: PropTypes.string,
  spawns: PropTypes.arrayOf(
    PropTypes.shape({
      allShareallPool: PropTypes.bool,
      allocationType: PropTypes.string,
      amount: PropTypes.string,
      charityDetails: PropTypes.object,
      checkIssuedDate: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
      ]),
      checkIssuedDateStr: PropTypes.string,
      checkNumber: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]),
      dollarbased: PropTypes.bool,
      grantAllocation: PropTypes.array,
      issueDate: PropTypes.string,
      issueDateStr: PropTypes.string,
      paymentId: PropTypes.number,
      purpose: PropTypes.string,
      recognition: PropTypes.any,
      recordStatus: PropTypes.string,
      scheduleId: PropTypes.number,
      spawnId: PropTypes.number,
      status: PropTypes.string
    })
  ),
  startDate: PropTypes.string,
  staticContext: PropTypes.any,
  updateSpawn: PropTypes.bool,
  updateSpawns: PropTypes.func,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CustomizeSpawn)
);
